module.exports = __webpack_public_path__ + "media/components/assets/icons/star_rank/starFull-6696262225c0c9ca4badc90d76480b17.svg";